import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle} from "@khanacademy/wonder-blocks-core";
import type {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {focusStyles} from "@khanacademy/wonder-blocks-styles";
import {border, color} from "@khanacademy/wonder-blocks-tokens";
import {LabelXSmall} from "@khanacademy/wonder-blocks-typography";

const StyledButton = addStyle("button");

type Props = {
    id?: string;
    icon?: React.ReactElement<React.ComponentProps<typeof PhosphorIcon>>;
    onClick: () => void;
    style?: any;
    disabled?: boolean;
    ["aria-labelledby"]?: string;
    children: React.ReactNode;
};

export default class ToolButton extends React.Component<Props> {
    render(): React.ReactNode {
        const {disabled, icon, id, children, onClick, style} = this.props;
        return (
            <StyledButton
                id={id}
                onClick={!disabled ? onClick : undefined}
                style={[
                    styles.linkStyledButton,
                    styles.toolButton,
                    disabled && styles.disabled,
                    style,
                ]}
                aria-disabled={disabled}
            >
                {icon}
                <LabelXSmall style={styles.text}>{children}</LabelXSmall>
            </StyledButton>
        );
    }
}

const styles = StyleSheet.create({
    linkStyledButton: {
        borderRadius: border.radius.radius_040,
        color: color.offBlack64,
        border: "none",
        backgroundColor: "transparent",
        // TODO(kevinb): figure out how to avoid setting this explicitly
        cursor: "pointer",
        padding: 0,
        margin: 0,

        ...focusStyles.focus,
    },
    toolButton: {
        display: "flex",
        alignItems: "center",
    },
    text: {
        marginLeft: 5,
    },
    disabled: {
        cursor: "default",
        color: color.offBlack32,
    },
});
